import parseActualContentConstraints from "./parseActualContentConstraints.mjs";
const getActualContentConstraints = (options = {}) => (structure) => {
  console.warn(
    "[deprecation warning]: getActualContentConstraints has been renamed to parseActualContentConstraints"
  );
  parseActualContentConstraints(options)(structure);
};
export {
  getActualContentConstraints as default
};
